import { render, staticRenderFns } from "./ChoiceRenderer.vue?vue&type=template&id=60a626c5&scoped=true"
import script from "./ChoiceRenderer.vue?vue&type=script&lang=js"
export * from "./ChoiceRenderer.vue?vue&type=script&lang=js"
import style0 from "../styles/base.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ChoiceRenderer.vue?vue&type=style&index=1&id=60a626c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@2.8.8_underscore@1.13.8_vue-t_oz4jpprlle4dra2pgsz5us5kba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a626c5",
  null
  
)

export default component.exports